import React, { createContext, useContext, useMemo } from "react";

import { usePersistState } from "../Common/hookUtils";

import { RegistrationForm } from "./types";

export type RegistrationContextType = RegistrationForm & {
  registrationContext: RegistrationForm;
  setRegistrationContext: React.Dispatch<React.SetStateAction<RegistrationForm>>;
};

const RegistrationContext = createContext<RegistrationContextType | undefined>(undefined);

export const useRegistrationContext = (): RegistrationContextType => {
  const context = useContext(RegistrationContext);
  if (context === undefined) {
    throw new Error("useRegistrationContext must be used within a RegistrationContextProvider");
  }
  return context;
};

export const RegistrationContextProvider: React.FC<{
  initialContext?: RegistrationForm;
  children?: React.ReactNode;
}> = ({ initialContext, children }) => {
  const [registrationContext, setRegistrationContext] = usePersistState<RegistrationForm>(
    "roo-hospital-registration-context",
    initialContext || {}
  );
  const memoizedValues = useMemo(
    () => ({
      registrationContext,
      setRegistrationContext,
    }),
    [registrationContext, setRegistrationContext]
  );
  return (
    <RegistrationContext.Provider value={memoizedValues}>{children}</RegistrationContext.Provider>
  );
};
